import { render, staticRenderFns } from "./listaDeUsuariosParaBloquearLiberar.vue?vue&type=template&id=07b572ae"
import script from "./listaDeUsuariosParaBloquearLiberar.vue?vue&type=script&lang=js"
export * from "./listaDeUsuariosParaBloquearLiberar.vue?vue&type=script&lang=js"
import style0 from "./listaDeUsuariosParaBloquearLiberar.vue?vue&type=style&index=0&id=07b572ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports